import { css } from "@emotion/css";
import { ActionButton, TextField } from "@octopusdeploy/design-system-components";
import { space } from "@octopusdeploy/design-system-tokens";
import type { Segment } from "@octopusdeploy/octopus-server-client";
import RemoveItemsList from "~/components/RemoveItemsList";
class RemoveSegmentsList extends RemoveItemsList<Segment> {
}
const style = {
    keyValuePair: css({
        display: "flex",
        gap: space[12],
    }),
};
export interface SegmentEditListProps {
    segments: Segment[];
    setSegments: (items: Segment[]) => void;
}
export function SegmentEditList(props: SegmentEditListProps) {
    const handleRemoveRow = (item: Segment) => {
        const data = [...props.segments];
        data.splice(data.indexOf(item), 1);
        props.setSegments(data);
    };
    const handleKeyChange = (index: number) => (newKey: string) => {
        const data = [...props.segments];
        data[index] = {
            ...data[index],
            Key: newKey,
        };
        props.setSegments(data);
    };
    const handleValueChange = (index: number) => (newValue: string) => {
        const data = [...props.segments];
        data[index] = {
            ...data[index],
            Value: newValue,
        };
        props.setSegments(data);
    };
    const handleAddClick = () => {
        props.setSegments([...props.segments, { Key: "", Value: "" }]);
    };
    const renderRow = (item: Segment, index: number) => {
        return (<div key={"KVI-" + index} className={style.keyValuePair}>
                <TextField value={item.Key} onChange={handleKeyChange(index)} label={"Key"}/>
                <TextField value={item.Value} onChange={handleValueChange(index)} label={"Value"}/>
            </div>);
    };
    const actionButton = <ActionButton key="Add" label={`Add Segment`} onClick={handleAddClick}/>;
    return <RemoveSegmentsList listActions={[actionButton]} data={props.segments} onRemoveRow={handleRemoveRow} onRow={renderRow} clearButtonToolTip={`Remove Segment`}/>;
}
